// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:23:59

export default {
  "id": "train-master",
  "slug": "train-master",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/d4c17d052b884e698de7ed2e9fcb31fe-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/d4c17d052b884e698de7ed2e9fcb31fe/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Train Master",
      "description": "All aboard for an exciting ride in Train Master! Tap and hold to control your train, race through stunning tracks, pick up passengers, and dodge obstacles. Navigate bustling cities and peaceful countryside as you master the tracks, upgrade your train, and become the ultimate conductor. Simple controls, thrilling challenges, and endless fun await. Start your adventure now! ",
      "instructions": "Tap and hold to control your train, race through scenic tracks, and pick up passengers along the way. But watch out-Do not hit cars or people! Can you master the tracks and become the ultimate train conductor?",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "arcade",
        "train"
      ]
    },
    "zh-CN": {
      "title": "火车大师",
      "description": "登上Train Master，体验一场刺激的旅程！点击并长按来控制你的火车，穿梭于壮丽的轨道，搭载乘客，躲避障碍。在城市的热闹和乡村的宁静中导航，掌握轨道，升级你的火车，成为终极列车长。简单操作，激动人心的挑战，无限乐趣等你来开启。现在开始你的冒险吧！",
      "instructions": "点击并保持以控制您的火车，穿梭在风景如画的轨道上，并在途中搭载乘客。但小心——不要撞到车辆或行人！您能掌握轨道，成为终极火车司机吗？",
      "genres": [
        "拼图"
      ],
      "tags": [
        "街机",
        "火车"
      ]
    },
    "zh-TW": {
      "title": "火車大師",
      "description": "上車吧！一起享受火車大師的刺激旅程！點擊並保持按住以操控你的火車，在驚人的軌道上競速，接載乘客，並避開障礙物。穿梭繁華都市和平靜鄉村，隨著你掌控軌道、升級你的火車，成為最終的車長。簡單的操作、刺激的挑戰和無窮的樂趣等待著你。啟動你的冒險吧！",
      "instructions": "點擊並按住以控制您的火車，穿越美景鐵軌，並在途中接載乘客。但小心——不要碰到車輛或人！您能夠駕馭鐵軌並成為最終的火車長嗎？",
      "genres": [
        "謎題"
      ],
      "tags": [
        "街機",
        "火車"
      ]
    },
    "zh-HK": {
      "title": "鐵路大師",
      "description": "全速啟航，享受驚險刺激的火車大師之旅！按住並拖移以控制你的火車，馳騁於壯觀的軌道上，接載乘客，並避開障礙。穿梭繁忙的城市和平靜的鄉村，當你掌握軌道，升級你的火車，成為最終的司機。簡單的控制，刺激的挑戰，無盡的樂趣在等待。立即開啟你的冒險之旅！",
      "instructions": "輕觸並按住以控制你的火車，穿過美麗的鐵路，並在路途中接載乘客。但請注意 - 不要撞到車輛或人！你能夠精通鐵路並成為最終的火車長嗎？",
      "genres": [
        "謎題"
      ],
      "tags": [
        "街機",
        "鐵路"
      ]
    },
    "ja": {
      "title": "トレインマスター",
      "description": "トレインマスターの興奮の旅に一緒に乗りましょう！タップ＆ホールドで電車を操作し、美しい線路を競速、乗客を拾い、障害物を回避しましょう。活気ある都市と静かな田舎を進みながら、線路をマスターし、電車をアップグレードし、究極の運転手に成長しましょう。簡単な操作、迫力のある挑戦、終わりなき楽しみが待っています。今すぐ冒険を始めましょう！",
      "instructions": "タップして長押しして列車を操作し、風景の美しい線を走り、途中で乗客を拾っていきましょう。しかし、注意してください-車両や人にぶつかってはいけません！線をマスターして最終的な列車の運転手になることができますか？",
      "genres": [
        "パズル"
      ],
      "tags": [
        "アーケード",
        "トレイン"
      ]
    },
    "ko": {
      "title": "트레인 마스터",
      "description": "트레인 마스터에서 흥미진진한 여행에 오세요! 기차를 제어하려면 탭하고 누르세요, 아름다운 트랙을 달리며 승객을 태우고 장애물을 피하세요. 도시의 붐비는 풍경과 평화로운 농촌을 돌아다니며 트랙을 마스터하고 기차를 업그레이드하여 최고의 기차장이 되세요. 간단한 제어, 흥미진진한 도전과 끝없는 즐거움이 기다립니다. 지금 여행을 시작하세요!",
      "instructions": "트레인을 제어하려면 탭하고 누르세요, 경치 좋은 트랙을 달려가며 승객을 태우세요. 하지만 주의하세요-차량이나 사람을 맞히지 마세요! 트랙을 마스터하고 최종적인 트레인 운전사가 될 수 있을까요?",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "어케이드",
        "트레인"
      ]
    },
    "fr": {
      "title": "Maître du Train",
      "description": "Montez à bord pour une aventure captivante dans Train Master ! Tapez et tenez pour contrôler votre train, traversez des pistes époustouflantes, ramassez des passagers et évitez les obstacles. Navigatez à travers des villes animées et des campagnes paisibles tout en maîtrisant les pistes, améliorez votre train et devenez le conducteur ultime. Commandes simples, défis captivants et divertissement sans fin vous attendent. Commencez votre aventure maintenant !",
      "instructions": "Tapez et maintenez pour contrôler votre train, traversez des lignes pittoresques et ramassez des passagers en cours de route. Mais faites attention - Ne froncez pas de voitures ou de personnes ! Pouvez-vous maîtriser les lignes et devenir le conducteur de train ultime ?",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "arcade : arcade\ntrain : train"
      ]
    }
  }
};
